module.exports = __webpack_public_path__ + "img/avatar.e3daa7a4.png";